import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { EDIT_CAMPAIGN, EDIT_CAMPAIGN_SUCCESS, EDIT_CAMPAIGN_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* editCampaign({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const { user_id } = payload?.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/campaigns`,
      method: 'PUT',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);
      yield put({
        type: EDIT_CAMPAIGN_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: EDIT_CAMPAIGN_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: EDIT_CAMPAIGN_ERROR, payload: error });
  }
}

export function* watchEditCampaign() {
  yield takeEvery(EDIT_CAMPAIGN, editCampaign);
}

function* editCampaignSaga() {
  yield all([fork(watchEditCampaign)]);
}

export default editCampaignSaga;
